import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    market_download: 'Загрузить',
    modal_title: 'Для отметки  учета посещения детей посредством QR, необходимо установить мобильное приложение "Учет посещений".  Для установки мобильного приложения перейдите по данной ссылке:',
  },
  kk: {
    market_download: 'Жүктеу',
    modal_title: 'Балалардың келуін QR арқылы белгілеу үшін «Учет посещений» мобильді қосымшасын орнату қажет. Мобильді қосымшаны орнату үшін мына сілтеме арқылы өтіңіз:',
  }
});
